export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonTracker64.979b4edc.svg";